var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Transfer component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTransfer extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.11222 9.41519L12.0004 2.68042L18.8886 9.41519C19.1848 9.70477 19.6596 9.69942 19.9492 9.40325C20.2388 9.10707 20.2334 8.63223 19.9372 8.34265L12.9375 1.49876C12.8171 1.37591 12.6737 1.27789 12.5155 1.21033C12.3526 1.14082 12.1774 1.10498 12.0004 1.10498C11.8234 1.10498 11.6482 1.14082 11.4853 1.21033C11.3271 1.27789 11.1837 1.37591 11.0634 1.49875L4.06357 8.34265C3.76739 8.63223 3.76205 9.10707 4.05162 9.40325C4.3412 9.69942 4.81604 9.70477 5.11222 9.41519ZM5.11222 14.5843C4.81604 14.2948 4.3412 14.3001 4.05162 14.5963C3.76205 14.8925 3.76739 15.3673 4.06357 15.6569L11.0634 22.5008C11.1837 22.6236 11.3271 22.7216 11.4853 22.7892C11.6482 22.8587 11.8234 22.8945 12.0004 22.8945C12.1774 22.8945 12.3526 22.8587 12.5155 22.7892C12.6737 22.7216 12.8171 22.6236 12.9375 22.5008L19.9372 15.6569C20.2334 15.3673 20.2388 14.8925 19.9492 14.5963C19.6596 14.3001 19.1848 14.2948 18.8886 14.5843L12.0004 21.3191L5.11222 14.5843Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTransfer.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTransfer.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTransfer.prototype, "size", void 0);
if (customElements.get('cat-icon-transfer') === undefined) {
    customElements.define('cat-icon-transfer', BlocksIconTransfer);
}
